module.exports = __webpack_public_path__ + "img/logo_text.06bcd223.svg";